import axios from 'axios';

import routes from 'app/routes';

export default {
  update: (memberId, params, successCallback = () => {}, errorCallback = () => {}) => {
    axios
      .patch(routes.api.students.update(memberId), params)
      .then((resp) => {
        successCallback(resp.data.data);
      }).catch((resp) => {
        errorCallback(resp.response.data);
      });
  },
};
